
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../shared/components/ui/select';
import { Globe } from 'lucide-react';
import { useLocalization } from '../../../localization/LocalizationProvider';

export const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale, availableLocales, isLoading } = useLocalization();

  const handleLanguageChange = (newLocale: string) => {
    setLocale(newLocale as 'en' | 'sw');
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <Select 
        value={locale} 
        onValueChange={handleLanguageChange}
        disabled={isLoading}
      >
        <SelectTrigger className="w-32">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {availableLocales.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.nativeName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
